export enum LogModuleRoutes {
    CLIENT_ACTIVITY_LOG = 'activity-log/clients',
    CASE_ACTIVITY_LOG = 'activity-log/cases/:id',
    BILLING_LOG = 'billing-log',
}
